import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';
import { ApiResponse } from '../../shared/models';
import {
  QuickCaptureProjectOption,
  QuickCaptureRequest,
  QuickCaptureResult,
  QuickCaptureUserOption,
} from './quick-capture.models';

@Injectable({ providedIn: 'root' })
export class QuickCaptureApiService {
  private get apiUrl(): string {
    return `${this.config.get('apiBaseUrl')}/QuickCapture`;
  }

  constructor(private http: HttpClient, private config: ConfigService) {}

  capture(request: QuickCaptureRequest): Observable<ApiResponse<QuickCaptureResult>> {
    return this.http.post<ApiResponse<QuickCaptureResult>>(`${this.apiUrl}/Capture`, request);
  }

  getAccessibleProjects(): Observable<ApiResponse<QuickCaptureProjectOption[]>> {
    return this.http.get<ApiResponse<QuickCaptureProjectOption[]>>(`${this.apiUrl}/AccessibleProjects`);
  }

  getAssignableUsers(): Observable<ApiResponse<QuickCaptureUserOption[]>> {
    return this.http.get<ApiResponse<QuickCaptureUserOption[]>>(`${this.apiUrl}/AssignableUsers`);
  }
}
